import classNames from 'classnames/bind';
import React from 'react';
import { RiRemoteControlLine } from 'react-icons/ri';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import styles from './common.module.scss';

import actions from '@/actions';
import useParamCommand from '@/hooks/command/mavlink/useParamCommand';
import { executeMavLinkCommand } from '@/utils/CommandUtils';

const cx = classNames.bind(styles);

const Panel = ({ data: robots }) => {
  const dispatch = useDispatch();
  const paramCommand = useParamCommand();

  const doCommand = (e) => {
    const value = e.currentTarget.dataset.commandValue;

    for (const robot of robots) {
      executeMavLinkCommand(robot, paramCommand.set('COM_CTRL_AUTH', value, 6));
    }
    dispatch(actions.command.resetActivePanels());
  };

  return (
    <div className={cx('container')}>
      <div className={cx('desc')}>When Manual Control is enabled, the onboard controller is deactivated</div>
      <div className={cx('buttons')}>
        <button type="button" data-command-value={1} className={cx('button')} onClick={doCommand}>
          ON
        </button>
        <button type="button" data-command-value={0} className={cx('button')} onClick={doCommand}>
          OFF
        </button>
      </div>
    </div>
  );
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Manual Control';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = false;
Command.commanderOnly = true;
Command.Icon = RiRemoteControlLine;
Command.Panel = Panel;

export default Command;
